export { AlternateLinkService, alternateLink } from './alternate-link.service.js';
